import { useRequest } from "../../../hooks/useRequest";
import { useCallback, useEffect, useMemo } from "react";
import { SolutionInListApiResponse } from "../../solution/types";
import routes from "../../../routes";

function useProjectsForInvestmentDropdown() {
  const { fetch, response, error, loading } = useRequest();

  const fetchInvestmentDetails = useCallback(
    () => fetch("GET", routes.api.solutions.base({})),
    [fetch],
  );

  useEffect(() => {
    fetchInvestmentDetails();
  }, [fetchInvestmentDetails]);

  const projects: SolutionInListApiResponse[] = useMemo(() => {
    if (response?.data) {
      return response.data.map(
        (project: { id: string; name: string; unitOfSale: string }) => ({
          id: project.id,
          name: project.name,
          unit: project.unitOfSale,
        }),
      );
    }
    return [];
  }, [response]);

  return {
    projects,
    error,
    alert,
    loading,
  };
}

export default useProjectsForInvestmentDropdown;
